export default [
    {
        name: 'cadastro-cliente',
        path: 'cliente',
        redirect: 'cliente/index',
        component: () => import(/* webpackChunkName: 'cadastro-cliente' */ '@/views/cadastro/cliente/Index'),
        children: [
            {
                meta: {title: 'Lista de clientes'},
                name: 'cadastro-cliente-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-cliente' */ '@/views/cadastro/cliente/List.vue'),
            },
            {
                meta: {title: 'Cadastro de cliente'},
                name: 'cadastro-cliente-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-cliente' */ '@/views/cadastro/cliente/Form.vue'),
            },
            {
                meta: {title: 'Edição de cliente'},
                name: 'cadastro-cliente-edit',
                path: 'edit/:id',
                props: route => ({id: parseInt(route.params.id)}),
                component: () => import(/* webpackChunkName: 'cadastro-cliente' */ '@/views/cadastro/cliente/Form.vue'),
            },
        ],
    },
]